module.exports = __webpack_public_path__ + "img/your_choking.871425ba.jpg";